import { TextField } from '@mui/material';
import { styled } from '@mui/material/styles';

export const StyledTextField = styled(TextField)(({ theme }) => ({
  // Estilo da label (rótulo)
  '& label': {
    color: '#9e9e9e',
  },
  // Estilo da label quando o campo está focado
  '& label.Mui-focused': {
    color: '#fff',
  },
  // Estilo da label quando o campo está desabilitado
  '& label.Mui-disabled': {
    color: '#757575',
  },

  // Estilos aplicados ao container do input
  '& .MuiOutlinedInput-root': {
    color: '#e0e0e0',
    backgroundColor: '#3A3A3D',

    // Seletor de autofill do navegador (Chrome/Safari)
    // Este seletor é mais específico para o input dentro do MUI
    '& .MuiInputBase-input:-webkit-autofill': {
      WebkitBoxShadow: '0 0 0 100px #3A3A3D inset !important',
      WebkitTextFillColor: '#e0e0e0 !important',
      caretColor: '#fff',
      borderRadius: 'inherit',
    },

    // Estilo do ícone dentro do campo (ex: ícone de visibilidade de senha)
    '& .MuiSvgIcon-root': {
      color: '#9e9e9e',
    },

    // Borda padrão
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: '#555',
    },
    // Borda ao passar o mouse
    '&:hover .MuiOutlinedInput-notchedOutline': {
      borderColor: '#777',
    },
    // Borda quando o campo está focado
    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
      borderColor: '#fff',
    },

    // --- ESTADOS ADICIONAIS ---

    // Estilo para o estado de ERRO
    '&.Mui-error .MuiOutlinedInput-notchedOutline': {
      borderColor: theme.palette.error.main, // Usa a cor de erro do tema (ex: #d32f2f)
    },
    '&.Mui-error label': {
      color: theme.palette.error.main,
    },

    // Estilo para o estado DESABILITADO
    '&.Mui-disabled': {
      backgroundColor: '#424242', // Um fundo um pouco diferente para indicar desativação
      color: '#757575',
    },
    '&.Mui-disabled .MuiOutlinedInput-notchedOutline': {
      borderColor: '#555',
    },
  },
}));
